import { render } from "./AnaliticalRevenue.vue?vue&type=template&id=decf5028&scoped=true"
import script from "./AnaliticalRevenue.vue?vue&type=script&lang=js"
export * from "./AnaliticalRevenue.vue?vue&type=script&lang=js"

import "./AnaliticalRevenue.vue?vue&type=style&index=0&id=decf5028&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-decf5028"]])

export default __exports__